// extracted by mini-css-extract-plugin
export default {"cabdd6171493d0b8b655dArrowsvIcon":"Link_cabdd6171493d0b8b655dArrowsvIcon__l+G2M","startAProject":"Link_startAProject__NWbav","link":"Link_link__XIOuG"};